import React, { Component } from 'react'
import {
    Form, FormGroup,
    InputGroup, InputGroupAddon, InputGroupText,
    Button, Input, Alert
} from 'reactstrap'
import Login from '../utilitarios/login'
import { AuthErrorCode } from '../utilitarios/firebaseErrors'
import { Icon } from 'react-icons-kit'
import { user } from 'react-icons-kit/fa/user'
import { ic_https } from 'react-icons-kit/md/ic_https'
import { eye } from 'react-icons-kit/fa/eye'
import { eyeSlash } from 'react-icons-kit/fa/eyeSlash'
import './login.css'

const login = new Login()

export default class LoginUsers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            patternEmail: '/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/',
            password: '',
            showPassword: false,
            messageLoginError: '',
            messageLoginErrorDetails: '',
            loading: false,
            toggleErrorDetalle: false,
            loginWithEmail: false
        }
        this.onInputChange = this.onInputChange.bind(this)
        this.toggleShowPass = this.toggleShowPass.bind(this)
        this.onLogin = this.onLogin.bind(this)
        this.loginSuccess = this.loginSuccess.bind(this)
        this.onLoginError = this.onLoginError.bind(this)
        this.onLoginFacebook = this.onLoginFacebook.bind(this)
        this.onLoginGoogle = this.onLoginGoogle.bind(this)
        this.onLoginEmail = this.onLoginEmail.bind(this)
        this.toggleErrorDetalle = this.toggleErrorDetalle.bind(this)
    }

    toggleErrorDetalle(e) {
        e.preventDefault()
        this.setState({
            toggleErrorDetalle: !this.state.toggleErrorDetalle
        })
    }

    onInputChange(el) {
        this.setState({
            [el.target.id]: el.target.value
        })
    }

    toggleShowPass(e) {
        e.preventDefault()
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    onLogin(e) {
        e.preventDefault()
        const { email, password } = this.state
        let usuario = {
            email,
            password
        }
        this.setState({
            loading: true
        })
        login.loginWithEmail(usuario, this.loginSuccess, this.onLoginError)
    }

    loginSuccess(user) {
        this.setState({
            loading: false
        })
        this.props.loginSuccess(user)
    }

    onLoginError(error) {
        console.error(error)
        this.setState({
            messageLoginError: AuthErrorCode(error.code),
            messageLoginErrorDetails: <div className="messageLoginErrorDetails">Código: {error.code}<p>Detalle: {error.message}</p></div>,
            loading: false
        })
    }

    onLoginFacebook(e) {
        e.preventDefault()
        login.loginWithFacebook(this.loginSuccess, this.onLoginError)
    }

    onLoginGoogle(e) {
        e.preventDefault()
        login.loginWithGoogle(this.loginSuccess, this.onLoginError)
    }

    onLoginEmail(e) {
        this.setState({
            loginWithEmail: true
        })
    }

    render() {
        return (
            <div>
                {this.state.loginWithEmail &&
                    <Form onSubmit={this.onSubmit}>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <Icon size={20} icon={user} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="email" onChange={this.onInputChange} value={this.state.email} name="email" id="email" placeholder="usuario@empresa.com" pattern={this.state.patternEmail} required />
                            </InputGroup>
                        </FormGroup>
                        {' '}
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <Icon size={20} icon={ic_https} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type={this.state.showPassword ? "text" : "password"} onChange={this.onInputChange} value={this.state.password} name="password" id="password" placeholder="Contraseña" required />
                                <InputGroupAddon addonType="append">
                                    <Button onClick={this.toggleShowPass} >
                                        {
                                            this.state.showPassword ?
                                                <Icon size={20} icon={eye} />
                                                :
                                                <Icon size={20} icon={eyeSlash} />
                                        }
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>

                        {' '}
                        <FormGroup>
                            <InputGroup>
                                <Button color='warning' onClick={this.onLogin} block disabled={this.state.loading} >
                                    {
                                        !this.state.loading ? "Ingresar" : "Iniciando sesión..."
                                    }
                                </Button>
                            </InputGroup>
                        </FormGroup>
                    </Form>
                }
                {
                    this.state.messageLoginError && <Alert color="danger">
                        {this.state.messageLoginError}
                        <a href="#" onClick={this.toggleErrorDetalle} className="verMasError float-right">{this.state.toggleErrorDetalle ? "Ocultar" : "Ver más"}</a>
                        {this.state.toggleErrorDetalle && this.state.messageLoginErrorDetails}
                    </Alert>
                }
                <FormGroup>
                    <InputGroup>
                        <Button onClick={this.onLoginFacebook} className="btn-Facebook" block> Iniciar con Facebook</Button>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <InputGroup>
                        <Button onClick={this.onLoginGoogle} className="btn-Google" block> Iniciar con Google</Button>
                    </InputGroup>
                </FormGroup>
                {
                    !this.state.loginWithEmail &&
                    <FormGroup>
                        <InputGroup>
                            <Button onClick={this.onLoginEmail} color='warning' block>Usuario y contraseña</Button>
                        </InputGroup>
                    </FormGroup>
                }

            </div>

        )
    }
}